
import { getTheme } from '@fluentui/react';

const { palette } = getTheme();

const IMAGE_DIM = {
  width: 96,
  height: 68,
  marginRight: 8,
};

const paddleWidth = 32;

// 680 px
const maxWidthOfUrlField =
  (6 * (IMAGE_DIM.width + IMAGE_DIM.marginRight)) + ((paddleWidth * 2) - IMAGE_DIM.marginRight);

export const getExtensionImagesControlStyles = () => ({
  carouselParent: { maxWidth: maxWidthOfUrlField },
  viewAllPlacementsButton: {
    right: 20,
    position: 'absolute',
    color: palette.themePrimary,
    '&:active': {
      color: palette.themePrimary,
    },
  },
  reCropButton: {
    marginRight: 8,
  },
});
